export default {
    myCenter: {
        personalInformation: '个人信息',
        pointChange: '积分变更',
        orderRecord: '订单记录',
        usageRecord: '使用记录',
        versionUpgradeSuccess: '版本升级成功',
        newFunctionUsageQuestion: '新增功能的使用问题可联系产品顾问',
        refresh: '刷新',
        source: '来源',
        amount: '数值',
        type: '类型',
        time: '时间',
        modify: '修改',
        signIn: '签到',
        share: '分享',
        avatar: '头像',
        nickname: '昵称',

        account: '账号',
        team: '团队',
        company: '企业',
        companyTip: '企业：',
        teamTip: '团队：',
        bindingPhone: '绑定手机号',
        bindingWx: '绑定微信',
        quitTeam: '退出团队',
        manage: '管理',
        balanceTip: '余额：',
        score: '积分',
        recharge: '充值',
        rules: '计费规则',
        queryBalanceRemind: '余额提醒',
        benefitsTip: '收益：',
        exchange: '兑换',
        view: '查看',
        benefitsRules: '收益规则',
        shareTip: '已为您生成专属链接',
        copyLink: '复制链接',
        queryBalanceRemindTitle: '积分余额预警设置',
        pleaseEnterBalanceRemindThreshold: '请输入积分余额预警阈值',
        setSuccess: '设置成功',
        enabled: '是否启用',
        threshold: '积分余额预警阈值',
        queryBalanceRemindTip: '积分余额低于设置的值时发送短信，公众号消息提醒',
        modifyPersonalInformation: '修改个人信息',
        avatarTip: '头像：',
        nicknameTip: '昵称：',
        phoneTip: '手机号：',
        emailTip: '邮箱：',
        modifyPassword: '修改密码',
        forgetPassword: '忘记密码',
        rechargeAmount: '充值金额',
        specialOffer: '特惠',
        rechargeNow: '立即充值',
        scanCodePay: '请使用微信扫码支付',
        billingRules: '计费规则',
        detailedRules: '详细规则',
        dailySignIn: '每日签到',
        dailySignInTip: '每日签到可随机获得积分',
        shareBenefits: '分享者收益',
        shareBenefitsTip: '分享 网页专属链接 邀请新用户,每个新用户注册，可获得300积分',
        creatorBenefits: '创作者收益',
        creatorBenefitsTip: '应用发布至广场，他人调用积分的 20% 将转化为你的积分收益。',
        activity: '有奖活动 🔥',
        activityTip: '分享您的LinkAI使用经验，赢取积分、现金等奖励，点此了解详情',
        learnMore: '了解详情',
        phoneNumber: '邮箱',
        password: '密码',
        oldPassword: '旧密码',
        newPassword: '新密码',
        verificationCode: '验证码',
        enterEmail: '请输入邮箱',
        pleaseEnterPhoneNumber: '请输入手机号',
        pleaseEnterNewPassword: '请输入新密码',
        pleaseEnterPassword: '请输入密码', 
        verificationCodeTip: '请输入验证码',
        enterVerificationCode: '请输入验证码',
        benefits: '收益',
        redeemIntegral: '兑换积分',
        orderNo: '订单号',
        charge: '积分充值',
        pleaseSelectSource: '请选择来源',
        pleaseSelectType: '请选择类型',
        app: '应用',
        pleaseSelectApp: '请选择应用',
        hitKnowledgeBase: '是否命中知识库',
        pleaseSelect: '请选择',
        hitKnowledgeBaseTip: '命中知识库',
        notHitKnowledgeBaseTip: '未命中知识库',
        startTime: '开始时间',
        endTime: '结束时间',   
        query: '查询',
        export: '导出',
        appName: '应用名称',
        prompt: '问题',
        answer: '回答',
        model: '模型 / 插件',
        tokenLength: 'Token长度',
        consumePoints: '消耗积分',
        statistics: '统计',
        user: '使用者',
        useTime: '使用时间',
        viewDetail: '查看详情',
        consumeTotalScore: '消耗总积分',
        useDetail: '使用详情',
        typeTip: '类型：',
        timeTip: '时间：',
        modelTip: '模型：',
        agent: '应用',
        tokenLengthTip: 'Token数量：',
        consumePointsTip: '消耗积分：',
        contextTip: '上下文',
        contextTipNumber: '上下文数量',
        knowledgeTip: '知识库：',
        knowledgeItems: '知识库条目：',
        knowledgeItemsNumber: '知识库条目数量：',
        questionTip: '问题：',
        answerTip: '答案：',
        hitNumberTip: '命中条数：',
        requestTip: '请求：',
        resultTip: '结果：',
        totalTokenLength: '总token长度 =应用设定+ 记忆 + 知识库命中 + 问题 + 回复',
        noData: '暂无数据',
        exportUsageRecord: '使用记录导出',
        workFlow: '工作流',
        getVerificationCode: '获取验证码',
        modifyPasswordSuccess: '修改密码成功',
        bindPhoneSuccess: '绑定手机号成功',
        imageUploadOnlySupportsJpegPngFormat: '图片上传只支持 jpeg,png 格式',
        imageSizeMustBeLessThan5MB: '图片大小需小于 5MB!',
        modifySuccess: '修改成功',
        operationSuccess: '操作成功，已兑换 {count} 积分',
        confirmExit: '是否确认退出{team}',
        confirmExitTip: '退出后将恢复您原有的账号内容',
        exitTeamSpace: '退出团队空间',
        exitCompanySpace: '退出企业空间',
        exitSuccessful: '退出成功',
        copySuccess: '复制成功',
        versionUpgrade: '版本升级',
        scoreRecharge: '积分充值',
    }
}